import { useScrollOffsets } from '@/hooks/element-hooks'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { NavItem } from '@/components/NavItem'
import { links } from '@/utils/link'
import {
  SplitViewHeader,
  SplitViewHeaderTitle,
} from '@/components/SplitView/SplitViewHeader'
import { ScrollView } from '@/components/ScrollView'

export interface ProfileNavProps {
  workspaceName: string
  shouldShowBilling: boolean
}

export function ProfileNav({
  workspaceName,
  shouldShowBilling,
}: ProfileNavProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()
  return (
    <Sandwich stretch>
      <SandwichBun>
        <SplitViewHeader compact scrollOffset={scrollOffset}>
          <SplitViewHeaderTitle>
            {workspaceName} &ndash; User Account
          </SplitViewHeaderTitle>
        </SplitViewHeader>
      </SandwichBun>
      <SandwichContent>
        <ScrollView ref={scrollRef}>
          <NavItem to={links.profileGeneral()} title="General">
            Manage your profile and visibility
          </NavItem>
          {shouldShowBilling && (
            <NavItem to={links.profileBilling()} title="Billing">
              Manage payment and payout methods
            </NavItem>
          )}
          <NavItem to={links.profileNotifications()} title="Notifications">
            Manage email and push notifications
          </NavItem>
        </ScrollView>
      </SandwichContent>
    </Sandwich>
  )
}
